import React from 'react';
import { useApiStatus } from '../../contexts/ApiStatusContext';

const ApiStatusBanner = ({ overlay = false }) => {
  const { isApiOnline, checking, retry } = useApiStatus();

  if (isApiOnline) return null;

  return (
    <div className={`api-status-banner${overlay ? ' api-status-banner--overlay' : ''}`} role="alert">
      <div className="api-status-banner__inner">
        <div className="api-status-banner__icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <div className="api-status-banner__text">
          <strong>Server unavailable</strong>
          <span>Cannot connect to the MediDev API. No data will load until the connection is restored.</span>
        </div>
        <button
          className="api-status-banner__retry"
          onClick={retry}
          disabled={checking}
        >
          {checking ? (
            <span className="api-status-banner__spinner" />
          ) : (
            <>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10" />
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
              </svg>
              Retry
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ApiStatusBanner;
